import React, {useState, useEffect} from "react";
import Select, {components} from "react-select";
import {useGlobal} from "reactn";
import {Arrow} from "BaseComponents/Icons/Svg";

export const MapBlockSelect = ({
                                   options,
                                   handleChange,
                                   SearchFieldText,
                                   NoHits,
                                   handleOverlay,
                                   multipleChoice,
                               }) => {
    const [theme] = useGlobal("theme");

    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                <Arrow color="#000" rotate={props.isFocused ? "-90" : "90"}/>
            </components.DropdownIndicator>
        );
    };

    const customStyles = {
        option: (provided, {data, isDisabled, isFocused, isSelected}) => ({
            ...provided,
            color: isSelected ? "white" : "black",
            padding: 15,
            cursor: "pointer",
            background: isSelected ? theme.colors.gradient : "white",
            border: isFocused ? "1px solid #515151" : "none",
            boxShadow: isFocused ? "0px 0px -10px #515151" : "none",
            "&:hover": {
                background: isSelected ? theme.colors.primaryDark : "#f7f7f7",
            },
        }),
        multiValue: (provided) => ({
            ...provided,
            cursor: "cursor",
            fontFamily: theme.font,
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: "black",
        }),
        control: (provided, {isFocused}) => ({
            ...provided,
            width: "auto",
            borderRadius: 50,
            padding: "7px 10px",
            border: "1px solid #515151",
            borderColor: "#949494",
            cursor: "text",
            boxShadow: "none",
            outline: isFocused ? "#515151 solid 2px " : "0",
            outlineOffset: "5px",
            "&:hover": {
                borderColor: theme.colors.primary,
            },
        }),
        valueContainer: (provided, state) => ({
            ...provided,
        }),
        container: (provided) => ({
            ...provided,
            width: "100%",
        }),
        placeholder: (provided) => ({
            ...provided,
            fontFamily: theme.font,
            color: "black",
        }),
        clearIndicator: (provided, state) => ({
            ...provided,
            paddingTop: 0,
            paddingBottom: 0,
            cursor: "pointer",
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 500,
            fontFamily: theme.font,
        }),
        indicatorSeparator: () => ({
            cursor: "pointer",
        }),
        IndicatorsContainer: () => ({
            marginRight: "80px",
            cursor: "pointer",
        }),
    };

    return (
        <Select
            aria-label={'Select'}
            isMulti={multipleChoice}
            isSearchable={false}
            isClearable={true}
            styles={customStyles}
            placeholder={SearchFieldText}
            options={options}
            components={{
                DropdownIndicator,
            }}
            onFocus={() => handleOverlay()}
            noOptionsMessage={() => NoHits}
            onChange={(selectedType) => handleChange(selectedType)}
        />
    );
};
